import { axios } from '../helpers/axios'
import { IClient, IClientFeatureMapping, IFeatures } from "../types/data-types"

const X_FEATURE_HEADER = 'X-Feature-Value'

export function setAxiosFeatureValueHeader(featureValue: string) {
    axios.defaults.headers[X_FEATURE_HEADER] = featureValue
  }


export function clearAxiosFeatureValueHeader() {
  
   axios.defaults.headers[X_FEATURE_HEADER] = undefined
}

export async function getAllFeatures() {
    const { data } = await axios.get<IFeatures[]>(`/api/features`)
    return data
  }
  
  export async function updateFeatureStatus({id, form}) {
    const { data } = await axios.put(`/api/features/${id}/update-status`, form)
    return data
  }
  
  export async function getFeaturesByClientId(clientId) {
    const { data } = await axios.get<IClientFeatureMapping[]>(`/api/client/${clientId}/features`)
    return data
  }
  
  export async function updateClientFeatures(form) {
    const { data } = await axios.put(`/api/feature-flags`, form)
    return data
  }
  
  
export async function getAllClientsWithFeatureMappings(featureId: number) {
  const { data } = await axios.get<IClient[]>(`/api/features/${featureId}/customers`)
  return data
}
